import { CreditDebitStatus, StatementTitle } from "../../../types/reconciliation";
import { Button, ButtonProps, message } from "antd";
import { useLazyGetConfirmableGroupsQuery } from "../../../redux/api/reconciliationsApiSlice";

export const MassiveStatementTitlesGroupSelectionButton = ({ buttonProps, afterFetch, status }: {
  buttonProps?: ButtonProps,
  afterFetch?: (titles: StatementTitle[]) => void,
  status?: CreditDebitStatus
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const [getConfirmableGroups, { isLoading }] = useLazyGetConfirmableGroupsQuery();

  return (
    <>
      {contextHolder}
      <Button
        loading={isLoading}
        disabled={isLoading}
        onClick={() => {
          getConfirmableGroups({ credit_debit_status: status ?? CreditDebitStatus.OK })
            .unwrap()
            .then((res) => {
              if (res.length === 0) {
                messageApi.info("Nessun titolo da confermare");
              }
              afterFetch?.(res);
            })
            .catch(err => {
              console.error("could not get confirmable groups due to an error: ", err);
              messageApi.error("Errore nella ricerca dei titoli");
            });
        }}
        {...buttonProps}
      >
        {buttonProps?.content ?? "Conferma titoli"}
      </Button>
    </>
  );
};